import { Link } from 'react-router-dom';

export default function LogoutPage() {
    return (
        <div className="h-screen flex flex-col gap-4 items-center justify-center">
            <Link to="/" className="text-white text-sm">
                <img
                    src={'/images/new_logo_placeholder.svg'}
                    alt="Logo"
                    className="h-7 w-auto"
                />
            </Link>
            <h4 className="text-h4 text-white">You have been logged out</h4>
        </div>
    );
}
